export const PERMISSOES = {
  PRODUTOS: 1, //pagina
  CATALOGOS: 2, //pagina
  CONFIGURACOES: 3, //pagina
  VISUALIZAR_PEDIDOS_GERENTE: 4, // visualizar pedidos de todos os vendedores
  VISUALIZAR_PEDIDOS_NAO_GERENTE: 5, //pedidos so dele
  VISUALIZAR_PEDIDOS_PREPOSTO: 6, //nao existe mais
  USUARIOS_GERENTE: 7, // pagina
  USUARIOS_PREPOSTO: 8, // nao existe mais
  RELATORIOS: 9, // pagina
  INDIQUE: 10, //nao existe mais
  PEDIDOS_EDICAO_TOTAL: 11, // edicao de pedidos de todos os vendedores
  PEDIDOS_EDICAO_RESTRITA: 12, // edicao de pedidos so dele (verificar, talvez só de pra alterar a situacao ate uma especifica)
  BOTAO_PEDIDOS: 13,
  BOTAO_CATALOGOS: 14,
  BOTAO_RELATORIOS: 15,
  BOTAO_PRODUTOS: 16,
  BOTAO_VENDEDORES: 17,
  BOTAO_INDIQUE: 18,
  REPLICAR_CATALOGOS_TODOS: 19,
  REPLICAR_CATALOGOS_PREPOSTO: 20,
  BOTAO_CESTAS_ABANDONADAS: 21,

  // Permissões granulares v2 (eixo A) — ids fixos a partir de 100.
  // Seed: docs/sql-permissoes-v2-seed.sql. Pedidos reusa 4/5/11/12/13.
  PRODUTOS_VISUALIZAR: 100,
  PRODUTOS_CRIAR_EDITAR: 101,
  PRODUTOS_EXCLUIR: 102,
  CATALOGOS_VISUALIZAR_GERAL: 110,
  CATALOGOS_VISUALIZAR_MEUS: 111,
  CATALOGOS_CRIAR_EDITAR_GERAL: 112,
  CATALOGOS_CRIAR_EDITAR_MEUS: 113,
  CATALOGOS_EXCLUIR: 114,
  RELATORIOS_TODOS: 130,
  RELATORIOS_PEDIDOS: 131,
  RELATORIOS_PRODUTOS: 132,
  RELATORIOS_CLIENTES: 133,
  RELATORIOS_PROMOCOES: 134,
  RELATORIOS_PERSONALIZADOS: 135,
  CONFIG_SUA_EMPRESA: 140,
  CONFIG_CATALOGO: 141,
  CONFIG_PROMOCOES: 142,
  CONFIG_ENTREGA_RETIRADA: 143,
  CONFIG_PAGAMENTO: 144,
  CONFIG_INTEGRACOES: 145,
  USUARIOS_CRIAR: 150,
  USUARIOS_EDITAR_GERAL: 151,
  USUARIOS_EDITAR_MEU: 152,
  USUARIOS_EXCLUIR: 153,
  METRICAS_GERAL: 160,
  METRICAS_MINHAS: 161,
  SACOLAS_GERAL: 170,
  SACOLAS_MINHAS: 171,
  ASSINATURAS_VER: 180,
};

export const TIPO_MIDIA = {
  IMAGEM: 1,
  YOUTUBE: 2,
};

// ----------------------------------------------------------------------------
// Permissões granulares v2 (eixo A) — configuração declarativa do painel.
// O painel (PainelPermissoes) renderiza estas áreas genericamente e edita um
// conjunto plano de ids em `usuario.permissoes`. Só ids finos são gravados; os
// "grossos" (rota/menu) são derivados no login (regra 2). Pedidos reusa ids já
// existentes (4/5/11/12/13). Ver docs/design-permissoes-v2.md.
// ----------------------------------------------------------------------------

// Sub-escopo Geral/Meus de uma ação (XOR, padrão "meus").
export interface EscopoPermissao {
  geral: number;
  meus: number;
  labelGeral?: string; // default "Geral"
  labelMeus?: string; // default "Meus"
}

// Uma pílula de ação dentro de uma área.
export interface AcaoPermissao {
  key: string;
  label: string;
  id?: number; // id concedido quando ativa (ação sem escopo)
  escopo?: EscopoPermissao; // se presente, mostra sub-pílulas Geral/Meus
  ativa?: string[]; // keys de ações que esta liga junto (dependência)
  exclusiva?: boolean; // ao ligar, desliga as demais da área; e vice-versa
  condicional?: string; // só aparece se contexto[condicional] === true
}

// Uma opção de um seletor XOR que cobre a área inteira (Pedidos/Sacolas/Métricas).
export interface OpcaoEscopoUnico {
  key: string;
  label: string;
  ids: number[]; // ids concedidos por esta opção
}

export type TipoArea = "acoes" | "escopo-unico" | "toggle";

export interface AreaPermissao {
  key: string;
  label: string;
  tipo: TipoArea;
  descricao?: string; // comentário curto abaixo do toggle
  acoes?: AcaoPermissao[]; // tipo "acoes"
  padraoKeys?: string[]; // ações ligadas ao ativar a área (default: primeira ação)
  opcoes?: OpcaoEscopoUnico[]; // tipo "escopo-unico" (primeira = padrão)
  id?: number; // tipo "toggle"
}

// Ordem conforme o redesenho do time.
export const AREAS_PERMISSOES: AreaPermissao[] = [
  {
    key: "pedidos",
    label: "Pedidos",
    tipo: "escopo-unico",
    descricao:
      "Define se o usuário vê e edita os pedidos de todos os vendedores ou apenas os próprios.",
    opcoes: [
      { key: "meus", label: "Meus", ids: [5, 12, 13] }, // ver+editar próprios + card
      { key: "geral", label: "Geral", ids: [4, 11, 13] }, // ver+editar todos + card
    ],
  },
  {
    key: "sacolas",
    label: "Sacolas abandonadas",
    tipo: "escopo-unico",
    descricao:
      "Define se o usuário vê as sacolas de todos os vendedores ou apenas as próprias.",
    opcoes: [
      { key: "minhas", label: "Minhas", ids: [PERMISSOES.SACOLAS_MINHAS] },
      { key: "geral", label: "Geral", ids: [PERMISSOES.SACOLAS_GERAL] },
    ],
  },
  {
    key: "relatorios",
    label: "Relatórios",
    tipo: "acoes",
    padraoKeys: ["todos"],
    acoes: [
      { key: "todos", label: "Todos", id: PERMISSOES.RELATORIOS_TODOS, exclusiva: true },
      { key: "pedidos", label: "Pedidos", id: PERMISSOES.RELATORIOS_PEDIDOS },
      { key: "produtos", label: "Produtos", id: PERMISSOES.RELATORIOS_PRODUTOS },
      { key: "clientes", label: "Clientes", id: PERMISSOES.RELATORIOS_CLIENTES },
      { key: "promocoes", label: "Promoções", id: PERMISSOES.RELATORIOS_PROMOCOES },
      {
        key: "personalizados",
        label: "Personalizados",
        id: PERMISSOES.RELATORIOS_PERSONALIZADOS,
        condicional: "relatoriosPersonalizados",
      },
    ],
  },
  {
    key: "produtos",
    label: "Produtos",
    tipo: "acoes",
    padraoKeys: ["visualizar"],
    acoes: [
      { key: "visualizar", label: "Visualizar", id: PERMISSOES.PRODUTOS_VISUALIZAR },
      {
        key: "criar_editar",
        label: "Criar/editar",
        id: PERMISSOES.PRODUTOS_CRIAR_EDITAR,
        ativa: ["visualizar"],
      },
      { key: "excluir", label: "Excluir", id: PERMISSOES.PRODUTOS_EXCLUIR, ativa: ["visualizar"] },
    ],
  },
  {
    key: "catalogos",
    label: "Catálogos",
    tipo: "acoes",
    padraoKeys: ["visualizar"],
    acoes: [
      {
        key: "visualizar",
        label: "Visualizar",
        escopo: {
          geral: PERMISSOES.CATALOGOS_VISUALIZAR_GERAL,
          meus: PERMISSOES.CATALOGOS_VISUALIZAR_MEUS,
        },
      },
      {
        key: "criar_editar",
        label: "Criar/editar",
        escopo: {
          geral: PERMISSOES.CATALOGOS_CRIAR_EDITAR_GERAL,
          meus: PERMISSOES.CATALOGOS_CRIAR_EDITAR_MEUS,
        },
        ativa: ["visualizar"],
      },
      { key: "excluir", label: "Excluir", id: PERMISSOES.CATALOGOS_EXCLUIR, ativa: ["visualizar"] },
    ],
  },
  {
    key: "metricas",
    label: "Métricas",
    tipo: "escopo-unico",
    descricao:
      "Define se o usuário vê as métricas de todos os vendedores ou apenas as próprias.",
    opcoes: [
      { key: "minhas", label: "Minhas", ids: [PERMISSOES.METRICAS_MINHAS] },
      { key: "geral", label: "Geral", ids: [PERMISSOES.METRICAS_GERAL] },
    ],
  },
  {
    key: "usuarios",
    label: "Usuários",
    tipo: "acoes",
    padraoKeys: ["editar"],
    acoes: [
      { key: "criar", label: "Criar", id: PERMISSOES.USUARIOS_CRIAR },
      {
        key: "editar",
        label: "Editar",
        escopo: {
          geral: PERMISSOES.USUARIOS_EDITAR_GERAL,
          meus: PERMISSOES.USUARIOS_EDITAR_MEU,
          labelMeus: "Meu",
        },
      },
      { key: "excluir", label: "Excluir", id: PERMISSOES.USUARIOS_EXCLUIR },
    ],
  },
  {
    key: "assinaturas",
    label: "Assinaturas",
    tipo: "toggle",
    id: PERMISSOES.ASSINATURAS_VER,
    descricao: "Permite ver e gerenciar a assinatura e o plano da conta.",
  },
  {
    key: "configuracoes",
    label: "Configurações",
    tipo: "acoes",
    padraoKeys: ["sua_empresa"],
    acoes: [
      { key: "sua_empresa", label: "Sua empresa", id: PERMISSOES.CONFIG_SUA_EMPRESA },
      { key: "catalogo", label: "Catálogo", id: PERMISSOES.CONFIG_CATALOGO },
      { key: "promocoes", label: "Promoções", id: PERMISSOES.CONFIG_PROMOCOES },
      { key: "entrega_retirada", label: "Entrega e retirada", id: PERMISSOES.CONFIG_ENTREGA_RETIRADA },
      { key: "pagamento", label: "Pagamento", id: PERMISSOES.CONFIG_PAGAMENTO },
      { key: "integracoes", label: "Integrações", id: PERMISSOES.CONFIG_INTEGRACOES },
    ],
  },
];

// Traduz um conjunto de permissões LEGADAS (ids de cargo, vindos de permissoes_cargos)
// para o modelo fino v2, para o painel refletir o acesso atual de usuários NÃO-customizados
// e o "preset" ao escolher um cargo base. É idempotente para ids finos (>= 100 passam
// adiante) e para Pedidos (4/5/11/12/13 já são o modelo fino).
export function legadoParaFino(ids: number[]): number[] {
  const has = (id: number) => ids.includes(id);
  const set = new Set<number>();
  const geral = has(PERMISSOES.VISUALIZAR_PEDIDOS_GERENTE); // 4 = marcador "vê tudo"

  // Pedidos: o pill Geral/Meus reflete o ESCOPO DE VISUALIZAÇÃO (4 vs 5), NÃO a edição. O cargo
  // Vendedor Interno tem a inconsistência legada de ver só os próprios (5) mas editar todos (11);
  // basear no 11 mostraria "Geral" enganosamente e, se personalizado, salvaria "ver todos".
  if (has(PERMISSOES.VISUALIZAR_PEDIDOS_GERENTE)) {
    [4, 11, 13].forEach((id) => set.add(id));
  } else if (has(PERMISSOES.VISUALIZAR_PEDIDOS_NAO_GERENTE)) {
    [5, 12, 13].forEach((id) => set.add(id));
  }

  if (has(PERMISSOES.PRODUTOS)) {
    // Produtos no legado = acesso total.
    [PERMISSOES.PRODUTOS_VISUALIZAR, PERMISSOES.PRODUTOS_CRIAR_EDITAR, PERMISSOES.PRODUTOS_EXCLUIR].forEach(
      (id) => set.add(id),
    );
  }
  if (has(PERMISSOES.CATALOGOS)) {
    // Hoje todo mundo (menos o suporte, até o Gerente) vê e mexe só nos PRÓPRIOS catálogos (filtro
    // id_usuario na listagem). "Geral" (ver/editar de todos) é capacidade nova do v2 que nenhum cargo
    // tem por padrão — o admin concede explicitamente. Por isso o pré-preenchimento é sempre MEUS.
    set.add(PERMISSOES.CATALOGOS_VISUALIZAR_MEUS);
    set.add(PERMISSOES.CATALOGOS_CRIAR_EDITAR_MEUS);
  }
  if (has(PERMISSOES.CONFIGURACOES)) {
    [
      PERMISSOES.CONFIG_SUA_EMPRESA,
      PERMISSOES.CONFIG_CATALOGO,
      PERMISSOES.CONFIG_PROMOCOES,
      PERMISSOES.CONFIG_ENTREGA_RETIRADA,
      PERMISSOES.CONFIG_PAGAMENTO,
      PERMISSOES.CONFIG_INTEGRACOES,
    ].forEach((id) => set.add(id));
  }
  if (has(PERMISSOES.RELATORIOS)) {
    set.add(PERMISSOES.RELATORIOS_TODOS);
  }
  if (has(PERMISSOES.USUARIOS_GERENTE)) {
    [PERMISSOES.USUARIOS_CRIAR, PERMISSOES.USUARIOS_EDITAR_GERAL, PERMISSOES.USUARIOS_EXCLUIR].forEach(
      (id) => set.add(id),
    );
  }
  if (has(PERMISSOES.BOTAO_CESTAS_ABANDONADAS)) {
    set.add(geral ? PERMISSOES.SACOLAS_GERAL : PERMISSOES.SACOLAS_MINHAS);
  }

  // Preserva ids finos já presentes (usuário já customizado ou conjunto misto).
  ids.forEach((id) => {
    if (id >= 100) set.add(id);
  });

  return Array.from(set);
}
